const state = {
  error: null,
  message: null,
  audioType: null
}

export default state
